import { ContainerModule } from 'inversify';
import CategoriesService from '../features/categories/data/service/CategoriesService';
import CategoriesRepository from '../features/categories/data/CategoriesRepository';
import { CategoriesServiceInterface } from '../features/categories/data/service/CategoriesService.types';
import { CategoriesRepositoryInterface } from '../features/categories/domain/CategoriesRepositoryInterface';
import GetCategoriesByStoreUseCase from 'src/features/categories/domain/useCases/GetCategoriesByStore';

export const categoriesBindings = new ContainerModule((bind) => {
  // Services
  bind<CategoriesServiceInterface>(CategoriesService).to(CategoriesService);

  // Repositories
  bind<CategoriesRepositoryInterface>(CategoriesRepository).to(
    CategoriesRepository
  );

  // Use cases
  bind<GetCategoriesByStoreUseCase>(GetCategoriesByStoreUseCase).to(
    GetCategoriesByStoreUseCase
  );
});
